import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const TOTAL_SECONDS = 15 * 60;
const BLINK_THRESHOLD = 5 * 60;
export function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const isBlinking = secondsLeft <= BLINK_THRESHOLD && secondsLeft > 0;
  const isExpired = secondsLeft <= 0;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full" data-id="element-31">
      <div className="py-1.5 px-4 text-center" style={{
      background: isBlinking ? 'linear-gradient(90deg, #1A0A0A 0%, #2A0A0A 50%, #1A0A0A 100%)' : 'linear-gradient(90deg, #0D0D1A 0%, #1a1a2e 50%, #0D0D1A 100%)',
      borderBottom: '1px solid rgba(212, 175, 55, 0.15)'
    }} data-id="element-32">
        {isExpired ? <p className="font-body text-red-400 text-xs font-semibold tracking-wide" data-id="element-33">
            ⚠️ EL TIEMPO SE AGOTÓ — Esta oferta puede no estar disponible mañana
          </p> : <div className="flex items-center justify-center gap-2" data-id="element-34">
            <span className="text-brand-ivory/70 font-body text-[10px] md:text-xs uppercase tracking-widest" data-id="element-35">
              ⏳ Oferta expira en:
            </span>
            <motion.div animate={isBlinking ? {
          opacity: [1, 0.3, 1]
        } : {
          opacity: 1
        }} transition={isBlinking ? {
          duration: 1,
          repeat: Infinity,
          ease: 'easeInOut'
        } : {}} data-id="element-36">
              <span className={`font-heading text-base md:text-lg font-bold tabular-nums tracking-wider ${isBlinking ? 'text-red-400' : 'text-brand-gold'}`} data-id="element-37">
                {pad(minutes)}:{pad(seconds)}
              </span>
            </motion.div>
          </div>}
      </div>
    </div>;
}